/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userStatus: null,
  activeSponser: null,
  activeStudy: null,
  activeSite: null,
  filterStudy: null,
  filterSites: null,
};

export const user = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setAllUSersStatus: (state, action) => {
      state.userStatus = action.payload;
    },
    setActiveSponsor: (state, action) => {
      state.activeSponser = action.payload;
    },
    setActiveStudy: (state, action) => {
      state.activeStudy = action.payload;
    },
    setActiveSite: (state, action) => {
      state.activeSite = action.payload;
    },
    setFilterStudy: (state, action) => {
      state.filterStudy = action.payload;
    },
    setFilterSite: (state, action) => {
      state.filterSites = action.payload;
    },
  },
});

export const { setAllUSersStatus, setActiveSponsor, setActiveStudy, setActiveSite, setFilterStudy, setFilterSite } = user.actions;

export default user.reducer;
